import React from 'react'
import { NavLink } from 'react-router-dom'
import programs from '../programs.json'

// Named in the existing biography: "multiple master degrees specialising in
// Nutraceuticals, Clinical Nutrition and Dietetics".
const SPECIALISMS = [
    {
        icon: 'icon-berry',
        title: 'Nutraceuticals',
        text: 'The study of foods and food-derived compounds, and the role they play in health.',
    },
    {
        icon: 'icon-fruit',
        title: 'Clinical Nutrition',
        text: 'Nutrition applied to specific health conditions, informed by medical history.',
    },
    {
        icon: 'icon-food',
        title: 'Dietetics',
        text: 'Translating nutritional science into practical, everyday eating plans.',
    },
];

// Sections below use only what the original biography already said; the single
// long paragraph was simply too dense to read as one block.
const APPROACH = [
    {
        title: 'Nourishing from within',
        text: 'Garima is a qualified clinical nutritionist and her passion is nourishing from within. Her vision is to make it simple to learn natural nutrition and the art of healthy living, with the end goal of transforming daily practices into healthy habits.',
    },
    {
        title: 'Understanding your body',
        text: 'She is here to help you understand what is going on beneath the surface of your anatomy, and to support you through the process of changing your diet with custom made meal plans that help you get back to living in tune with your body.',
    },
    {
        title: 'Support that lasts',
        text: 'Through developing self-awareness and analysing the mechanisms of your body, Garima is committed to mentoring clients to be their best and to learn how to nourish their body, mind and soul — supporting you while you reclaim your health.',
    },
];

function About() {
    return (
        <section className="welcome-area about-page">
            <div className="container">
                <div className="row">
                    <div className="col-12 col-lg-5">
                        <div className="welcome-right">
                            <div className="video-holder">
                                {/* Displayed at 370px; 2x and 3x are supplied so it
                                    stays sharp on high-DPI screens. WebP first, JPEG
                                    for anything that cannot decode it. */}
                                <picture>
                                    <source
                                        type="image/webp"
                                        srcSet={`${process.env.PUBLIC_URL}/images/resources/aboutgarima-740.webp 740w, ${process.env.PUBLIC_URL}/images/resources/aboutgarima-1110.webp 1110w`}
                                        sizes="(max-width: 991px) 300px, 40vw"
                                    />
                                    <img
                                        src={`${process.env.PUBLIC_URL}/images/resources/aboutgarima-740.jpg`}
                                        srcSet={`${process.env.PUBLIC_URL}/images/resources/aboutgarima-740.jpg 740w, ${process.env.PUBLIC_URL}/images/resources/aboutgarima-1110.jpg 1110w`}
                                        sizes="(max-width: 991px) 300px, 40vw"
                                        width="740"
                                        height="1075"
                                        alt="Garima Rathore"
                                    />
                                </picture>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-lg-7">
                        <div className="health-coacher">
                            <div className="text-box">
                                <div className="coacher-name">
                                    <h2>Garima Rathore</h2>
                                    <span className="thm-clr">Clinical Nutritionist</span>
                                </div>
                                <div className="coacher-content">
                                    <p className="about-lead">
                                        Nutrism was founded on a simple idea: that healthy eating should fit
                                        the person, not the other way round. Every plan starts with a
                                        one-to-one consultation and is built around your medical history,
                                        preferences, allergies and the way you actually live.
                                    </p>

                                    {/* Sits beside the portrait rather than in its own
                                        full-width band, so the tall photo is not left
                                        with an empty column next to it. */}
                                    <h3 className="inline-block-title">Qualifications</h3>
                                    <ul className="credential-list stacked">
                                        {SPECIALISMS.map((item) => (
                                            <li key={item.title}>
                                                <span className="credential-icon">
                                                    <span className={item.icon}></span>
                                                </span>
                                                <span className="credential-body">
                                                    <span className="credential-title">{item.title}</span>
                                                    <span className="credential-text">{item.text}</span>
                                                </span>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <h2 className="block-title">Her approach</h2>
                <div className="approach-list">
                    {APPROACH.map((item) => (
                        <div className="approach-item" key={item.title}>
                            <h3>{item.title}</h3>
                            <p>{item.text}</p>
                        </div>
                    ))}
                </div>

                <h2 className="block-title">Areas of focus</h2>
                <p className="section-intro">
                    Programmes are tailored to the individual, across the areas below.
                </p>
                <ul className="focus-grid">
                    {programs.map((program) => (
                        <li key={program.name}>
                            <NavLink to="/programs">{program.name}</NavLink>
                        </li>
                    ))}
                </ul>
            </div>
        </section>
    )
}

export default About
